module.exports = __webpack_public_path__ + "static/img/404.91dbe1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/404.png
// module id = 551
// module chunks = 1